import React from "react";
import ViewItems from "./Items/ViewItems";

const Index = () => {
  return <div>
    <ViewItems />
  </div>;
};

export default Index;
